"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CreateEditReservationController = /*#__PURE__*/function (_PageController) {
  _inherits(CreateEditReservationController, _PageController);

  var _super = _createSuper(CreateEditReservationController);

  function CreateEditReservationController() {
    var _this2;

    _classCallCheck(this, CreateEditReservationController);

    _this2 = _super.call(this);
    _this2._reservationFormEl = "reservation-form";
    _this2._modelFindByTailNumberWrapeprEl = ".model-find-by-tail-number";
    _this2._autoEnterModelWrapper = ".model-number-autoenter";
    _this2._noModelFindByTailNumberWrapperEl = ".no-model-find";
    _this2._modelNumberWrapperEl = ".model-number";
    _this2._inputModelEl = ".input-model";
    _this2._inputAutoenterModelEl = ".input-modelautoenter";
    _this2._inputTailNumber = ".input-tailnumber";
    _this2._buttonCorrentIncorrectModelEl = ".model-correct-incorrect";
    _this2._selectAirport = ".select-airfield";
    _this2._inputArrivalDatepicker = ".datepicker-arrival";
    _this2._inputDepartureDatepicker = ".datepicker-departure";
    _this2.selectedAirportId = $(_this2._selectAirport).val();
    _this2.arrivalSelectedDate = false;

    _this2.updateSelectWithAirport();

    _this2.departureDateTimePicker = null;

    _this2.initDateTimePickerDeparture();

    _this2.initDateTimePickerArrival();

    _this2.openTab($(".tab[data-tab='step-1']"));

    _this2.initPrevNextButton();

    _this2.verifyTailNumber();

    $(document).on("keypress", 'form', function (e) {
      var code = e.keyCode || e.which;

      if (code == 13) {
        e.preventDefault();
        return false;
      }
    });
    $('.guide-icon').webuiPopover({
      title: 'Title',
      content: 'Content',
      placement: 'auto',
      cache: false
    });
    return _this2;
  }

  _createClass(CreateEditReservationController, [{
    key: "updateSelectWithAirport",
    value: function updateSelectWithAirport() {
      var _this = this;

      $("html").on("change", _this._selectAirport, function () {
        _this.selectedAirportId = $(this).val();
        $(".service-option").addClass("hide");
        $('.service-option[data-airport="' + _this.selectedAirportId + '"]').removeClass("hide");
      });
    }
  }, {
    key: "verifyTailNumber",
    value: function verifyTailNumber() {
      var _this = this;

      $("html").on("input", _this._inputTailNumber, function () {
        var inputEl = _this._inputTailNumber;
        var tab = $(this).parents(".tab");
        var continueButton = $(".go-to-next-tab", tab);
        var tailNumber = $(inputEl).val();
        continueButton.addClass("disable");
        $(".tail-number-loader").show();
        setTimeout(function () {
          naja.makeRequest('POST', verifyTailNumberUrl, {
            value: tailNumber
          }, {
            history: false
          }).then(function (payload) {
            if (Object.keys(payload).length > 0) {
              if ("model_name" in payload) {
                $(_this._inputAutoenterModelEl).val(payload.model_name);
                $(_this._autoEnterModelWrapper).show();
                $(_this._modelFindByTailNumberWrapeprEl).show();
                $(_this._noModelFindByTailNumberWrapperEl).hide();
                $(_this._modelNumberWrapperEl).hide();
                $(_this._buttonCorrentIncorrectModelEl).show();
                $(_this._inputModelEl).attr("disabled", true);
              } else {
                $(_this._inputAutoenterModelEl).val("");
                $(_this._autoEnterModelWrapper).show();
                $(_this._modelFindByTailNumberWrapeprEl).hide();
                $(_this._modelNumberWrapperEl).show();
                $(_this._noModelFindByTailNumberWrapperEl).show();
                $(_this._inputModelEl).removeAttr("disabled");
                $(_this._buttonCorrentIncorrectModelEl).hide();
              }

              continueButton.removeClass("disable");
              $(".tail-number-loader").hide();
            }
          })["catch"](function (error) {
            $(".model-number").removeClass("hide");
          });
        }, 500);
      });
      $("#model-is-correct").click(function () {
        $(_this._buttonCorrentIncorrectModelEl).hide();
        $(_this._inputModelEl).attr("disabled", true);
      });
      $("#model-is-incorrect").click(function () {
        $(_this._autoEnterModelWrapper).hide();
        $(_this._buttonCorrentIncorrectModelEl).hide();
        $(_this._modelFindByTailNumberWrapeprEl).show();
        $(_this._noModelFindByTailNumberWrapperEl).hide();
        $(_this._modelNumberWrapperEl).show();
        $(_this._inputModelEl).removeAttr("disabled");
      });
    }
  }, {
    key: "openTab",
    value: function openTab(tab) {
      $(".tab").hide();
      $(".tab-opener").removeClass("active");
      tab.show();
      var tabNumber = $(tab).attr("data-tab");
      var tabOpener = $(".tab-opener[data-tab='" + tabNumber + "']");
      tabOpener.addClass("active");

      if (tabNumber === "step-4") {
        var pair;
        var airfieldServices;
        var serviceName;

        (function () {
          var wrapper = $(".overview-of-reservation");
          $('[data-form-name]', wrapper).hide();
          var formData = new FormData(document.querySelector('form'));
          var services = [];
          var airfieldId = null;

          var _iterator = _createForOfIteratorHelper(formData.entries()),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              pair = _step.value;
              var name = pair[0];
              var value = "";

              (function () {
                switch (name) {
                  case "airfield":
                    airfieldId = pair[1];
                    value = airfields.filter(function (airfield) {
                      return airfield['id'] === pair[1];
                    })[0].name;
                    break;

                  case "model":
                    $('[data-form-name="modelautoenter"]').hide();

                    if (pair[1].length > 1) {
                      value = pair[1];
                    }

                    break;

                  case "services[]":
                    var serviceId = pair[1].split("_")[1];
                    var airfield = airfields.filter(function (airfield) {
                      return airfield['id'] === airfieldId;
                    })[0];

                    if (airfield.hasOwnProperty("services")) {
                      airfieldServices = airfield.services;
                      serviceName = airfieldServices.filter(function (service) {
                        return service['id'] === serviceId;
                      })[0].name;
                      services.push(serviceName);
                      break;
                    }

                  default:
                    value = pair[1];
                    break;
                }
              })();

              var dataWrapper = $('[data-form-name="' + name + '"]');

              if (dataWrapper.length > 0) {
                if (value !== "") {
                  $(".value", dataWrapper).html(value);
                  dataWrapper.show();
                } else {
                  dataWrapper.hide();
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var servicesWrapper = $('[data-form-name="services"]');

          if (services.length > 0) {
            $(".value", servicesWrapper).html(services.join(", "));
            $(".value", servicesWrapper).show();
          } else {
            $(".value", servicesWrapper).hide();
          }
        })();
      }
    }
  }, {
    key: "initPrevNextButton",
    value: function initPrevNextButton() {
      var _this = this;

      $(document).on("click", ".go-to-next-tab", function () {
        var tabWrapper = $(this).parents(".tab");
        var nextTab = tabWrapper.next(".tab");

        var validationSuccessful = _this.validateAllControllInputesInTab(tabWrapper);

        if (validationSuccessful) {
          _this.openTab(nextTab);
        }
      });
      $(document).on("click", ".go-to-prev-tab", function () {
        var tabWrapper = $(this).parents(".tab");
        var nextTab = tabWrapper.prev(".tab");

        _this.openTab(nextTab);
      });
    }
  }, {
    key: "validateAllControllInputesInTab",
    value: function validateAllControllInputesInTab(tabWrapper) {
      var _this = this;

      var form = document.getElementById(this._reservationFormEl);
      Nette.formErrors = [];
      var formElementValidationCorrent = true;
      $("input,textarea,select", tabWrapper).each(function (index) {
        var el = $(this)[0];
        var controlValidation = Nette.validateControl(el, null, false);

        if (controlValidation === false) {
          formElementValidationCorrent = false;
        }
      });
      console.log("errors");
      console.log(form);
      console.log(Nette.formErrors);
      Nette.showFormErrors(form, Nette.formErrors);
      return formElementValidationCorrent;
    }
  }, {
    key: "filterAllowTimesForDateTimePicker",
    value: function filterAllowTimesForDateTimePicker(ct, type) {
      var _this = this;

      var dt = new Date(ct);
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1 < 10 ? "0" + (dt.getMonth() + 1) : dt.getMonth() + 1;
      var day = dt.getDate();
      var formatedDate = year + "-" + month + "-" + day;
      var allAllowTimes = airfieldsAllowTimeForReservation[type][_this.selectedAirportId];
      var blockReservatioTimes = [];

      if (dateTimesBlockByReservation.hasOwnProperty(type) && dateTimesBlockByReservation[type].hasOwnProperty(_this.selectedAirportId) && dateTimesBlockByReservation[type][_this.selectedAirportId].hasOwnProperty(formatedDate)) {
        blockReservatioTimes = dateTimesBlockByReservation[type][_this.selectedAirportId][formatedDate];
      }

      var finalTimes = [];
      finalTimes = allAllowTimes.filter(function (el) {
        return blockReservatioTimes.indexOf(el) < 0;
      });
      return finalTimes;
    }
  }, {
    key: "initDateTimePickerArrival",
    value: function initDateTimePickerArrival() {
      var curentDate = new Date();
      curentDate.setDate(curentDate.getDate() + 1);
      var minDateObj = new Date();
      minDateObj.setDate(minDateObj.getDate() + 1);

      var _this = this;

      $(_this._inputArrivalDatepicker).datetimepicker({
        format: 'M d, Y H:i',
        defaultDate: curentDate,
        minDate: minDateObj,
        closeOnWithoutClick: false,
        onShow: function onShow(ct) {
          var timesAvailable = _this.filterAllowTimesForDateTimePicker(ct, "arrival");

          _this.arrivalSelectedDate = ct;
          this.setOptions({
            allowTimes: timesAvailable,
            defaultTime: timesAvailable[0]
          });
        },
        onSelectDate: function onSelectDate(ct, $i) {
          var timesAvailable = _this.filterAllowTimesForDateTimePicker(ct, "arrival");

          _this.arrivalSelectedDate = ct;
          this.setOptions({
            allowTimes: timesAvailable,
            defaultTime: timesAvailable[0]
          });
        },
        timepickerScrollbar: true,
        scrollInput: false
      });
    }
  }, {
    key: "initDateTimePickerDeparture",
    value: function initDateTimePickerDeparture() {
      var curentDate = new Date();
      curentDate.setDate(curentDate.getDate() + 1);

      var _this = this;

      $(_this._inputDepartureDatepicker).datetimepicker({
        format: 'M d, Y H:i',
        defaultDate: curentDate,
        closeOnWithoutClick: false,
        onShow: function onShow(ct) {
          var timesAvailable = _this.filterAllowTimesForDateTimePicker(ct, "departure");

          this.setOptions({
            minDate: _this.arrivalSelectedDate,
            allowTimes: timesAvailable,
            defaultTime: timesAvailable[0]
          });
        },
        onSelectDate: function onSelectDate(ct, $i) {
          var timesAvailable = _this.filterAllowTimesForDateTimePicker(ct, "departure");

          this.setOptions({
            minDate: _this.arrivalSelectedDate,
            allowTimes: timesAvailable,
            defaultTime: timesAvailable[0]
          });
        },
        timepickerScrollbar: false,
        scrollInput: false
      });
    }
  }]);

  return CreateEditReservationController;
}(PageController);